import { Flex, Text, LinkButton, WarningIcon, useModal } from 'vvs-uikit'
import { useTheme } from 'styled-components'
import { useWeb3React } from '@web3-react/core'
import { useTranslation } from 'contexts/Localization'
import { useConnectionError } from 'state/user/hooks'

import SwitchNetworkModal from 'components/Menu/UserMenu/SwitchNetworkModal'
import useVvsGotchiWalletModal from 'components/Menu/VvsGotchiMenu/useWalletModal'

import { SwtichNetworkBtn } from 'components/Menu/VvsGotchiMenu/styles'

const WalletStateWarnBanner = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { account } = useWeb3React()

  const [connectionError] = useConnectionError()

  const [onSwitchNetworkModal] = useModal(<SwitchNetworkModal ActionButton={SwtichNetworkBtn} />)
  const { onPresentConnectModal } = useVvsGotchiWalletModal()

  if (connectionError) {
    return (
      <Flex background={theme.colors.gotchiPink} p={3}>
        <WarningIcon width="16px" fill="black" />
        <Text color="black" fontSize="13px" fontWeight="700" px={2}>
          {t('Wrong network.')}{' '}
          <LinkButton fontSize="13px" fontWeight="700" color="black" underline="always" onClick={onSwitchNetworkModal}>
            {t('Switch network to Cronos Chain')}
          </LinkButton>
          {t('.')}
        </Text>
      </Flex>
    )
  }

  if (!account) {
    return (
      <Flex background={theme.colors.goldLight} p={3}>
        <WarningIcon width="16px" fill="black" />
        <Text color="black" fontSize="13px" fontWeight="700" px={2}>
          {t('Wallet not connected. Please')}{' '}
          <LinkButton fontSize="13px" fontWeight="700" color="black" underline="always" onClick={onPresentConnectModal}>
            {t('Connect your wallet')}
          </LinkButton>
          {t('.')}
        </Text>
      </Flex>
    )
  }

  return null
}

export default WalletStateWarnBanner
